export const FgbHelpsEmployerSectionProps = [
    {
        img: '/v1544719327/icons/attract_2x.png',
        label: 'Attract',
        description:
            'Increase your company’s visibility and enhance your employer brand',
    },
    {
        img: '/v1544719327/icons/engage_2x.png',
        label: 'Engage',
        description:
            'Share your story about why your company is a great place for women',
    },
    {
        img: '/v1544719328/icons/retain_2x.png',
        label: 'Convert',
        description:
            'Drive more female applicants to apply for your open positions',
    },
];

export const EmployerBrandingProgramProps = [
    {
        image: {
            src: '/v1/employer/marketing/a_jobs.jpg',
            alt: '',
        },
        content: {
            label: 'UNLIMITED JOB POSTS',
            title: 'Drive Top Female Candidates to Your Jobs',
            description:
                'Optimize the visibility to your open positions. Our unlimited job postings and personalized email alerts ensure that more qualified women see and apply to your open jobs.',
        },
    },
    {
        image: {
            src: '/v1/employer/marketing/b_employer_profile.jpg',
            alt: '',
        },
        content: {
            label: 'EMPLOYER PROFILE',
            title: 'Tell Your Brand Story to Millions of Women',
            description:
                'Showcase why your company is a great place for women to work. Use the employer branded profile to highlight your company benefits, feature female employees, and more.',
        },
    },
    {
        image: {
            src: '/v1/employer/marketing/c_main_page_content.jpg',
            alt: '',
        },
        content: {
            label: 'CUSTOM BRANDED CONTENT',
            title: 'Bring Your Diversity Initiatives to Life',
            description:
                "Authentically communicate your employer brand story. We develop custom content that is designed for and promoted to the female talent you're looking to attract.",
        },
    },
    {
        image: {
            src: '/v1/employer/marketing/d_dedicated_team.jpg',
            alt: '',
        },
        content: {
            label: 'CUSTOMER SERVICE',
            title: 'Work With a Dedicated Team of Diversity Experts',
            description:
                'Power your success with a dedicated customer service team. Get on-boarding support, monthly performance reports and quarter business reviews.',
        },
    },
];

export const byTheNumbersSection = [
    {
        img: '/v1544719328/icons/Stat_icon_1_2x.png',
        title: '9 Million',
        description: 'Active female job seekers in our community',
    },
    {
        img: '/v1544719330/icons/Stat_icon_2_2x.png',
        title: '150+',
        description: 'Companies work with us',
    },
    {
        img: '/v1544719331/icons/Stat_icon_3_2x.png',
        title: '160+',
        description: 'Partners to reach diverse female talent',
    },
];

export const pressLogos = [
    {
        img: '/v1/employer/marketing/Press%20Logos/nyt.png',
    },
    {
        img: '/v1/employer/marketing/Press%20Logos/quartz.png',
    },
    {
        img: '/v1/employer/marketing/Press%20Logos/fast_company.png',
    },
    {
        img: '/v1/employer/marketing/Press%20Logos/cnbc.png',
    },
    {
        img: '/v1/employer/marketing/Press%20Logos/fortune.png',
    },
];
